module.exports = __webpack_public_path__ + "img/diploma_director.b97e583b.png";